import defaultOptions from './options'

export default {
  props: {
    gutter: Number,

    span: Number,

    push: Number,

    pull: Number,

    zIndex: Number,

    wrap: Boolean,

    inline: Boolean,

    reverse: Boolean,

    noGutter: Boolean,

    hasGutter: Boolean,

    background: String,

    padding: String,

    width: String,

    height: String,

    center: Boolean,

    start: Boolean,

    end: Boolean,

    top: Boolean,

    middle: Boolean,

    bottom: Boolean,

    values: Array,
  },

  data() {
    return {
      needGutter: true,
    }
  },

  provide() {
    return {
      $Row: this,
    }
  },

  inject: {
    $Row: {
      from: '$Row',
      default: this,
    },
  },

  computed: {
    layoutStyle() {
      const style = {}
      const span = this.span
      const parentFlexDirection = this.parentFlexDirection()
      const inline = this.parentProperty('inline')

      // 槽宽
      if (!this.noGutter && (this.needGutter || this.hasGutter)) {
        style.padding = `${this.currentGutter / 2}px`
      }

      if (this.padding) {
        style.padding = this.padding
      }

      if (this.zIndex) {
        style.zIndex = this.zIndex
      }

      if (this.background) {
        style.background = this.background
      }

      // Grids 布局
      if (this.parentProperty('wrap') && !inline) {
        let size = 100

        if (span) {
          size *= span / this.currentGrids
        }

        style.flexBasis = `${size}%`

        if (parentFlexDirection === 'column') {
          style.maxHeight = `${size}%`
          style.height = `${size}%`
        } else {
          style.maxWidth = `${size}%`
          style.width = `${size}%`
        }
      } else if (span) {
        style.flexGrow = span
        style.flexShrink = 1 / span
      }

      if (inline) {
        style.flexGrow = 0
        style.flexShrink = 0
        style.flexBasis = 'auto'
      }

      // push
      if (this.push) {
        const push = 100 * this.push / this.currentGrids

        if (parentFlexDirection === 'row') {
          style.marginLeft = `${push}%`
        } else if (parentFlexDirection === 'column') {
          style.marginTop = `${push}%`
        }
      }

      if (this.pull) {
        const pull = 100 * this.pull / this.currentGrids

        if (parentFlexDirection === 'row') {
          style.marginRight = `${pull}%`
        } else if (parentFlexDirection === 'column') {
          style.marginBottom = `${pull}%`
        }
      }

      if (this.width) {
        style.width = this.width
      }

      if (this.height) {
        style.height = this.height
      }

      return style
    },

    layoutClass() {
      const classes = {
        reverse: this.reverse,
        wrap: this.wrap,
        'no-fit': this.noFit,
        start: this.start,
        center: this.center,
        end: this.end,
        top: this.top,
        middle: this.middle,
        bottom: this.bottom,
      }

      if (this.zIndex) {
        classes[`zpa-shadow-${this.zIndex}`] = true
      }

      return classes
    },

    noFit() {
      return !!(this.width || this.height)
    },

    currentGutter() {
      const defaultValue = defaultOptions.gutter
      const $Row = this['$Row']

      if (this.gutter !== undefined) return this.gutter

      if ($Row) return $Row.gutter !== undefined ? $Row.gutter : defaultValue

      return defaultValue
    },

    currentGrids() {
      const defaultValue = defaultOptions.grids
      const $Row = this['$Row']

      if (this.gutter !== undefined) return this.grids

      if ($Row) return $Row.grids !== undefined ? $Row.grids : defaultValue
    },
  },

  methods: {
    $changeGutter() {
      // 如果Column或者Row本身包含了至少一个[Column/Row]
      // 说明它自己是不需要gutter的，在子组件创建的时候，会调用他直接父组件来判断是不是需要Gutter

      const children = this.$children.filter(c => c.$changeGutter instanceof Function)
      this.needGutter = !children.length

      // if (!this.needGutter) console.log('no need gutter')
    },

    parentFlexDirection() {
      let parent = this.$parent

      while (parent) {
        if (parent.flexDirection instanceof Function) break
        parent = parent.$parent
      }

      if (parent) return parent.flexDirection()
    },

    parentProperty(key) {
      let parent = this.$parent
      while (parent) {
        // 通过 flexDirection 属性判断是不是 row 或者 column 组件
        if (parent.flexDirection instanceof Function) break
        parent = parent.$parent
      }

      if (parent) return parent[key]
    },
  },

  created() {
    if (this.$parent.$changeGutter instanceof Function) {
      this.$parent.$changeGutter()
    }
  },
}
